export const QR_USER = '_QR_USER';
